// Ambient color wash behind the app. Symphony renders a flat canvas (per the
// dashboard design), so there's no wash there.

export function CosmicBackdrop() {
  return null;
}

